import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import {
  formatBall,
  formatDrawId,
  formatMoney,
  GAME_META,
  GAME_POWER,
} from "../VietlottCompound/constants";

dayjs.extend(utc);

function Money({ value }) {
  return (
    <span className="vietlott-sidebar-money">
      {formatMoney(value)}
      <sup>đ</sup>
    </span>
  );
}

export default function CompactVietlottResult({ result, date, loading = false }) {
  const meta = result ? GAME_META[result.game] : null;
  const numbers = result ? [...(result.numbers || [])].sort((a, b) => a - b) : [];
  const isPower = result?.game === GAME_POWER;
  const prizes = result?.prizes || {};

  return (
    <div className={`vietlott-sidebar-kq${loading ? " is-loading" : ""}`}>
      {loading || !result || !meta ? (
        <div className="xoso-sidebar-kq__empty">
          {loading ? "" : `Chưa có KQ ${dayjs(date).format("DD/MM")}`}
        </div>
      ) : (
        <>
          <div className="vietlott-sidebar-meta">Kỳ vé {formatDrawId(result.drawId)}</div>
          <ul className={`vietlott-sidebar-balls${isPower ? " has-bonus" : ""}`}>
            {numbers.map((n, i) => (
              <li key={`${n}-${i}`} className="vietlott-sidebar-ball">
                {formatBall(n)}
              </li>
            ))}
            {isPower && result.bonusNumber != null ? (
              <li className="vietlott-sidebar-ball is-special">{formatBall(result.bonusNumber)}</li>
            ) : null}
          </ul>
          <table className="vietlott-sidebar-prizes">
            <thead>
              <tr>
                <th>Giải</th>
                <th>SL</th>
                <th>Giá trị</th>
              </tr>
            </thead>
            <tbody>
              {meta.prizeRows.map((row) => {
                const prize = prizes[row.key] || {};
                const jackpot = row.key.startsWith("jackpot");
                return (
                  <tr key={row.key}>
                    <td className={`vietlott-sidebar-prizes__name${jackpot ? " is-jackpot" : ""}`}>
                      {row.label}
                    </td>
                    <td>{prize.winners != null ? formatMoney(prize.winners) : "—"}</td>
                    <td
                      className={`vietlott-sidebar-prizes__amount${jackpot ? " is-jackpot" : ""}`}
                    >
                      <Money value={prize.amount} />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </>
      )}
    </div>
  );
}
